<template>
  <section>
    <router-link :to="{ name: 'Coupon', params: { id: couponId || 'discount' }, query: { email: email } }"
      class="d-flex align-items-center justify-content-between discount-banner">
      <span class="d-flex align-items-center justify-content-between content-left">
        <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_684_6871)">
            <path d="M0 3.26733L2.63765 4.04626L4.36412 8.41776L0 3.26733Z" fill="#C0E9FF"/>
            <path d="M6.09072 4.04626L8.72837 3.26733L4.36426 8.41776" fill="#4756D9"/>
            <path d="M2.6377 4.04626H6.09062L4.36416 8.41777L2.6377 4.04626Z" fill="#4F80FF"/>
            <path d="M3.03734 2.18634H5.70696L6.09062 4.04622H2.6377L3.03734 2.18634Z" fill="#1A1A1A"/>
            <path d="M1.55078 2.01148L2.86162 1.64586L4.41224 1.58228L5.81899 1.64586L7.24172 2.04327L6.05878 2.28172H4.41224H2.66979L1.55078 2.01148Z" fill="#C7E4FF"/>
            <path d="M2.6377 4.04622L4.41212 2.18634L6.09062 4.04622H2.6377Z" fill="#6D718F"/>
            <path d="M1.55078 2.01147L2.63782 4.04621L4.41224 2.18633L1.55078 2.01147Z" fill="#DDDFEB"/>
            <path d="M2.63755 4.04621L1.55052 2.01147L0.0478516 3.26729L2.63755 4.04621Z" fill="black"/>
            <path d="M6.76238 2.05914L6.09098 4.04619L4.39648 2.18631L6.76238 2.05914Z" fill="#99B6FF"/>
            <path d="M2.63766 4.04621L1.55062 2.01147L0 3.26729L2.63766 4.04621Z" fill="#BDC1DB"/>
            <path d="M6.09082 4.04621L7.22582 2.01147L8.72848 3.26729L6.09082 4.04621Z" fill="#333333"/>
            <path d="M4.34818 4.06211L2.87748 2.58374L2.6377 4.04621L4.34818 4.06211Z" fill="#82BBFF"/>
            <path d="M1.2627 3.6488L2.87727 2.58374L2.63748 4.04621L1.2627 3.6488Z" fill="#D6F0FF"/>
            <path d="M1.13499 2.34534L1.26288 3.64884L0 3.26733L1.13499 2.34534Z" fill="#E2F5FF"/>
            <path d="M4.34766 4.06214L5.88229 2.59967L6.10609 4.04624L4.34766 4.06214Z" fill="#81A4FF"/>
            <path d="M7.46542 3.64883L5.88281 2.59967L6.10662 4.04624L7.46542 3.64883Z" fill="#5466FF"/>
            <path d="M7.62568 2.34528L7.46582 3.64878L8.7287 3.26726L7.62568 2.34528Z" fill="#4F61FF"/>
            <path d="M2.87793 2.58375L4.39658 2.18634L5.88326 2.59965L4.34862 4.06211L2.87793 2.58375Z" fill="#A6CFFF"/>
            <path d="M6.76204 2.0592L5.88281 2.59968L7.46542 3.64884L7.62527 2.34534L6.76204 2.0592Z" fill="#8793FF"/>
            <path d="M2.06194 2.04327L1.13477 2.34531L1.26265 3.64881L2.87721 2.58375L2.06194 2.04327Z" fill="white"/>
            <path d="M4.39643 2.18634L2.87778 2.58375L2.0625 2.04327L4.39643 2.18634Z" fill="#C0D9FF"/>
            <path d="M2.06194 2.04327L1.13477 2.3453L1.5504 2.01147L2.06194 2.04327Z" fill="#D1EEFF"/>
            <path d="M7.22531 2.01147L6.76172 2.05916L7.62496 2.3453L7.22531 2.01147Z" fill="#5465FF"/>
            <path opacity="0.2" d="M4.34765 4.06207L3.6123 6.55781L4.36364 8.41769L5.14694 6.52602L4.34765 4.06207Z" fill="white"/>
            <path opacity="0.12" d="M7.4655 3.6488L5.14756 6.52605L4.36426 8.41772L6.15466 6.31939L7.4655 3.6488Z" fill="white"/>
            <path opacity="0.34" d="M3.61261 6.55784L1.2627 3.6488L2.68543 6.44657L4.36394 8.41772L3.61261 6.55784Z" fill="white"/>
            <path d="M8.53538 2.02852L8.60587 2.63057L8.97644 3.10263L8.37867 3.1558L7.89163 3.51668L7.83581 2.92097L7.46524 2.44892L8.06301 2.39574L8.53538 2.02852Z" fill="#E7F6FF"/>
            <path d="M1.9182 6.43066L2.06207 6.7009L2.31784 6.84397L2.06207 6.98704L1.9182 7.24138L1.77433 6.98704L1.51855 6.84397L1.77433 6.7009L1.9182 6.43066Z" fill="#E6F6FF"/>
          </g>
          <defs>
            <clipPath id="clip0_684_6871">
              <rect width="9" height="9" fill="white" transform="translate(0 0.5)"/>
            </clipPath>
          </defs>
        </svg>
        <span>{{ $t("pricing.discountBanner.waitlistExclusive") }}</span>
        <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_684_6871)">
            <path d="M0 3.26733L2.63765 4.04626L4.36412 8.41776L0 3.26733Z" fill="#C0E9FF"/>
            <path d="M6.09072 4.04626L8.72837 3.26733L4.36426 8.41776" fill="#4756D9"/>
            <path d="M2.6377 4.04626H6.09062L4.36416 8.41777L2.6377 4.04626Z" fill="#4F80FF"/>
            <path d="M3.03734 2.18634H5.70696L6.09062 4.04622H2.6377L3.03734 2.18634Z" fill="#1A1A1A"/>
            <path d="M1.55078 2.01148L2.86162 1.64586L4.41224 1.58228L5.81899 1.64586L7.24172 2.04327L6.05878 2.28172H4.41224H2.66979L1.55078 2.01148Z" fill="#C7E4FF"/>
            <path d="M2.6377 4.04622L4.41212 2.18634L6.09062 4.04622H2.6377Z" fill="#6D718F"/>
            <path d="M1.55078 2.01147L2.63782 4.04621L4.41224 2.18633L1.55078 2.01147Z" fill="#DDDFEB"/>
            <path d="M2.63755 4.04621L1.55052 2.01147L0.0478516 3.26729L2.63755 4.04621Z" fill="black"/>
            <path d="M6.76238 2.05914L6.09098 4.04619L4.39648 2.18631L6.76238 2.05914Z" fill="#99B6FF"/>
            <path d="M2.63766 4.04621L1.55062 2.01147L0 3.26729L2.63766 4.04621Z" fill="#BDC1DB"/>
            <path d="M6.09082 4.04621L7.22582 2.01147L8.72848 3.26729L6.09082 4.04621Z" fill="#333333"/>
            <path d="M4.34818 4.06211L2.87748 2.58374L2.6377 4.04621L4.34818 4.06211Z" fill="#82BBFF"/>
            <path d="M1.2627 3.6488L2.87727 2.58374L2.63748 4.04621L1.2627 3.6488Z" fill="#D6F0FF"/>
            <path d="M1.13499 2.34534L1.26288 3.64884L0 3.26733L1.13499 2.34534Z" fill="#E2F5FF"/>
            <path d="M4.34766 4.06214L5.88229 2.59967L6.10609 4.04624L4.34766 4.06214Z" fill="#81A4FF"/>
            <path d="M7.46542 3.64883L5.88281 2.59967L6.10662 4.04624L7.46542 3.64883Z" fill="#5466FF"/>
            <path d="M7.62568 2.34528L7.46582 3.64878L8.7287 3.26726L7.62568 2.34528Z" fill="#4F61FF"/>
            <path d="M2.87793 2.58375L4.39658 2.18634L5.88326 2.59965L4.34862 4.06211L2.87793 2.58375Z" fill="#A6CFFF"/>
            <path d="M6.76204 2.0592L5.88281 2.59968L7.46542 3.64884L7.62527 2.34534L6.76204 2.0592Z" fill="#8793FF"/>
            <path d="M2.06194 2.04327L1.13477 2.34531L1.26265 3.64881L2.87721 2.58375L2.06194 2.04327Z" fill="white"/>
            <path d="M4.39643 2.18634L2.87778 2.58375L2.0625 2.04327L4.39643 2.18634Z" fill="#C0D9FF"/>
            <path d="M2.06194 2.04327L1.13477 2.3453L1.5504 2.01147L2.06194 2.04327Z" fill="#D1EEFF"/>
            <path d="M7.22531 2.01147L6.76172 2.05916L7.62496 2.3453L7.22531 2.01147Z" fill="#5465FF"/>
            <path opacity="0.2" d="M4.34765 4.06207L3.6123 6.55781L4.36364 8.41769L5.14694 6.52602L4.34765 4.06207Z" fill="white"/>
            <path opacity="0.12" d="M7.4655 3.6488L5.14756 6.52605L4.36426 8.41772L6.15466 6.31939L7.4655 3.6488Z" fill="white"/>
            <path opacity="0.34" d="M3.61261 6.55784L1.2627 3.6488L2.68543 6.44657L4.36394 8.41772L3.61261 6.55784Z" fill="white"/>
            <path d="M8.53538 2.02852L8.60587 2.63057L8.97644 3.10263L8.37867 3.1558L7.89163 3.51668L7.83581 2.92097L7.46524 2.44892L8.06301 2.39574L8.53538 2.02852Z" fill="#E7F6FF"/>
            <path d="M1.9182 6.43066L2.06207 6.7009L2.31784 6.84397L2.06207 6.98704L1.9182 7.24138L1.77433 6.98704L1.51855 6.84397L1.77433 6.7009L1.9182 6.43066Z" fill="#E6F6FF"/>
          </g>
          <defs>
            <clipPath id="clip0_684_6871">
              <rect width="9" height="9" fill="white" transform="translate(0 0.5)"/>
            </clipPath>
          </defs>
        </svg>
      </span>
      <div class="content-center d-flex align-items-center">
        <span class="off-30">{{ saleOff || $t("pricing.discountBanner.saleOff") }}</span>
        <span>{{ $t("pricing.discountBanner.businessPlan") }}</span>
      </div>
      <span class="content-right">{{ $t("pricing.discountBanner.claimButton") }}</span>
    </router-link>
  </section>
</template>

<script>

export default {
  name: "DiscountBanner",
  filters: {},
  props: {
    email: {
      type: String
    },
    couponId: {
      type: String
    },
    saleOff: {
      type: String
    }
  },
  computed: {

  }
}
</script>
<style lang="scss" scoped>
  .discount-banner {
    height: 88px;
    padding: 0 60px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("~@/core/assets/banner/discount_banner.png");
    margin-bottom:32px;

    .content-left {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 4px 16px;
      width: 208px;
      height: 32px;
      background: rgba(40, 76, 204, 0.8);
      border: 1px solid #0A2BA4;
      box-sizing: border-box;
      box-shadow: 0px 6px 12px 2px rgba(0, 0, 0, 0.1);
      border-radius: 16px;
      font-weight: 500;
      font-size: 16px;
      color: #fff;
    }

    .content-center {
      span {
        font-weight: 600;
        font-size: 24px;
        color: #F7F7F8;
      }

      .off-30 {
        color: #FFAA00;
        font-weight: bold;
        font-size: 32px;
        margin-right: 9px;
      }
    }

    .content-right {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 16px;
      width: 189px;
      height: 48px;
      background: linear-gradient(114.38deg, #F4F6FA 61.03%, #DFE2EB 166.05%);
      box-shadow: 0px 2px 6px rgba(84, 90, 116, 0.1), 0px 6px 12px 2px rgba(84, 90, 116, 0.1);
      border-radius: 3px;
      font-weight: 500;
      font-size: 20px;
      color: #0A2BA4;
    }

    @media (min-width: 1440px) and (max-width: 1552px) {
      padding: 0 16px;

      .content-left {
        width: 188px;
        font-size: 15px;
      }

      .content-right {
        width: 153px;
        height: 40px;
        font-size: 16px;
      }
    }

    @media (max-width: 1440px) {
      padding: 0 16px;
    }

    @media (max-width: 1350px) {
      .content-center {
        span {
          font-size: 20px;
        }

        .off-30 {
          font-size: 24px;
        }
      }
    }

    @media (max-width: 1150px) {
      .content-left {
        width: 188px;
        font-size: 15px;
      }

      .content-center {
        span {
          font-size: 16px;
        }

        .off-30 {
          font-size: 21px;
        }
      }

      .content-right {
        width: 153px;
        height: 40px;
        font-size: 16px;
      }
    }
  }
</style>
